import { dataCheckApi } from "@/shared/apis";

export async function validateUnitEstablishNumber(unitEstablishNumber: string): Promise<boolean> {
    if (!unitEstablishNumber) {
        return true;
    }
    return dataCheckApi.queryCheckUnitEstablishNumber(unitEstablishNumber);
}
